import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Divider, Form, Steps } from "antd";
import { useEffect, useRef, useState } from "react";
import {
  setApplicantObj,
  setAutoObj,
} from "../../../../features/folder/folderSlice";
import InsideHeader from "../../../../components/InsideHeader";
import ActivityDetails from "./ActivityDetails";
import ActivitySetting from "./ActivitySetting";
import ActivityScheduling from "./scheduling/ActivityScheduling";
import dayjs from "dayjs";

export default function ActivityStepper() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeObjActivity } = useSelector((state) => ({
    activeObjActivity: state.folder.activeObj["activity"],
  }));
   const {autoObj} =  useSelector((state)=>state.folder)
  const formRef = useRef(null);

  const [current, setcurrent] = useState(0);

  const onFinish = async () => {
    // const normalizedOrgObj = {
    //   ...applicantObj,
    //   usrDob: normalizeDateToLocal(applicantObj?.usrDob),
    // };
    // const res = await dispatch(
    //   save({
    //     ...normalizedOrgObj,
    //     url: "api/v1/public/create-organisation",
    //   })
    // );
    // if (res?.payload?.success) {
    //   await toast.success(res?.payload?.messages?.message);
    //   await dispatch(cleanApplicantObj());
    //   await form.resetFields();
    //   await navigate("/registration-success");
    // } else {
    //   toast.error(res?.payload?.messages?.message);
    // }
  };

  function handleNext() {
    setcurrent(current + 1);
  }

  function handleBack() {
    setcurrent(current - 1);
  }

  const steps = [
    {
      key: 0,
      title: "Activity Details",
      content: <ActivityDetails handleNext={handleNext} form={form} />,
    },

    {
      key: 1,
      title: "Activity Setting",
      content: (
        <ActivitySetting
          handleBack={handleBack}
          handleNext={handleNext}
          form={form}
        />
      ),
    },

    {
      key: 2,
      title: "Activity Scheduling",
      content: (
        <ActivityScheduling
          handleBack={handleBack}
          handleNext={handleNext}
          form={form}
        />
      ),
    },
  ];

  const items = steps.map((item) => ({
    key: item.key,
    title: item.title,
    icon: item.icon,
  }));

  useEffect(() => {
    form.setFieldsValue({
      ...activeObjActivity,
      jaaStartDate: activeObjActivity?.jaaStartDate
        ? dayjs(new Date(activeObjActivity?.jaaStartDate))
        : null,
    });
  }, [activeObjActivity, form]);

  return (
    <div className="overflow-y-scroll flex flex-col  h-full w-full ">
      <InsideHeader
        title="Activities"
        subtitle="Manage your activities such as meetings and interviews"
        back={false}
      />
      <div className="white_card mt-[1.5rem]">
        <Form
          onValuesChange={(data) => {
            dispatch(setAutoObj({ ...autoObj, ...data }));
          }}
          layout="vertical"
          ref={formRef}
          name="registration"
          onFinish={onFinish}
          scrollToFirstError
          form={form}
          // initialValues={applicantObj}
          className="w-full lg:px-[3rem] px-0"
        >
          <div className="hidden lg:flex">
            <Steps
              className="w-full"
              current={current}
              labelPlacement="vertical"
              items={items}
            />
          </div>

          <div className="my-[1.5rem] lg:px-[10rem] px-0">
            {steps[current].content}
          </div>
        </Form>
      </div>
    </div>
  );
}
